export const RESET = 'COMPANY_PRODUCT_LIST_RESET'
export const SET_ITEMS = 'COMPANY_PRODUCT_LIST_SET_ITEMS'
export const SET_ERROR = 'COMPANY_PRODUCT_LIST_SET_ERROR'
export const SET_VIEW = 'COMPANY_PRODUCT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'COMPANY_PRODUCT_LIST_TOGGLE_LOADING'
